// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#ac8445","colorSecondary":"#414d55","bodyBg":"#d9d9d9"};